<template>
  <div>
    <div class="schedule" :key="key" v-for="(group, key) in value">
      <div class="schedule-title">
        <div>
          {{ key }}
        </div>
      </div>
      <div class="schedule-list">
        <component
          :is="item.event_id ? 'router-link' : 'div'"
          :tor="`/${item.page_slug || ''}?event_id=${item.event_id}`"
          class="schedule-item"
          :class="{ dark: item.preview_urls }"
          :style="
            item.preview_urls
              ? { backgroundImage: `url(${item.preview_urls.large})` }
              : {}
          "
          v-for="item in group"
          :key="item.id"
          @click="clickSchedule(item)"
        >
          <div class="schedule-item__time">
            {{
              item.start_at | moment("timezone", "America/New_York", "h:mm A")
            }}
          </div>
          <div class="schedule-item__title">{{ item.title }}</div>
        </component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Schedule",
  props: {
    value: Object
  },
  methods: {
    clickSchedule(item) {
      if (item.event_id) {
        this.$gtag.event("Schedule", {
          event_category: "click",
          event_label: "scheduleId",
          value: item.event_id
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.schedule {
  &-title {
    font-weight: 300;
    font-size: 36px;
    line-height: 1.1em;
    color: #676767;
    border-bottom: 2px solid $primary;
    margin: 60px 0 30px 0;
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: baseline;

    &__extra {
      font-weight: 600;
      font-size: 14px;
      text-align: right;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: #101820;
    }
  }

  &-item {
    padding: 45px;
    text-align: center;
    margin: 20px 0;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    position: relative;
    background-size: cover;
    background-position: center;
    border-radius: 10px;
    overflow: hidden;
    align-items: center;
    display: flex;
    justify-content: flex-start;
    text-decoration: none;
    background-image: url("~@/assets/schedule.png");
    color: white;

    &.dark:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
    }

    &__time {
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      text-transform: uppercase;
      margin-right: 80px;
    }

    &__title {
      font-weight: 900;
      font-size: 48px;
      line-height: 48px;
      text-align: left;
    }
  }
}

@media screen and (max-width: 960px) {
  .schedule {
    &-item {
      padding: 35px;
      min-height: 160px;
      flex-direction: column;

      &__time {
        margin-right: 0;
      }

      &__title {
        font-size: 2em;
        text-align: center;
        line-height: 1.5em;
      }
    }

    &-title {
      display: none;
    }
  }
}
</style>
